import i18n from './i18n/config'
import { translateServerError, type ServerError } from './translate-server-error'

/**
 * LACUNA #7 (aba Tela, regra #7) — turn a raw engine error envelope into the
 * text `onError` shows in the chat bubble, WITHOUT ever forwarding the raw
 * server text itself. A mapped business `code` (`equipment.duplicateTag.
 * inPlant` and friends) gets its pt-BR/en-US/es-419 phrase; anything else —
 * including the engine's numeric HTTP-status `code` on an uncaught exception
 * (`chat-rest.ts`'s catch-all: `{code: <httpStatus>, message: error.message}`,
 * where `message` is a raw JS `Error.message`, often English) — falls back to
 * the generic translated message. The raw text, when there is one, only ever
 * reaches `console.error` for support triage.
 */
export function displayForServerError(raw: {
  code?: unknown
  message?: unknown
  details?: unknown
}): string {
  const err: ServerError = {
    code: typeof raw.code === 'string' ? raw.code : undefined,
    message: typeof raw.message === 'string' ? raw.message : undefined,
    details:
      raw.details && typeof raw.details === 'object'
        ? (raw.details as Record<string, unknown>)
        : undefined,
  }
  if (err.message) {
    console.error('[chat-stream] raw server error (support log only):', err.message)
  }
  return translateServerError(err, i18n.t)
}
